/**
 * LA ENTRADA ESTIMADA SE VE COMO ESTIMADA (TUR-T3 parte panel, Ares #37942; API nexo-api 658, servido 1.6.895).
 *
 * Regla innegociable de la tarea: una hora que la persona NO marco (hora base del contador, puerta del conteo o marca
 * administrativa) nunca se muestra igual que una marcada. Decide la API (entradaEstimada, regla 4 en el SQL): el panel no
 * recalcula, solo lo dice con PALABRAS, no solo con color, y nombra el metodo en el idioma del dueno.
 * Lo valioso es el contador: cuantos dias necesito estimacion cada persona en el periodo. No acusa: muestra el patron.
 * Sin sancion ni pedido de correccion: esperan decision de Josse.
 *
 * Sin DOM: lo prueba scripts/check-entrada-estimada.mjs.
 */

const texto = (v) => (v == null ? '' : String(v));

/** El metodo de la entrada en palabras. Lo que no se conoce no se inventa: se dice que no la marco la persona. */
const METODOS = {
  confirmado_por_contador: 'confirmada por el contador',
  auto_conteo: 'por la puerta del conteo',
  administrativo: 'registrada por administración',
  propuesta_autorizada: 'por una propuesta autorizada'
};

export function metodoEnPalabras(metodo) {
  return METODOS[texto(metodo).trim().toLowerCase()] || 'no la marcó la persona';
}

/** La entrada de la fila es estimada? Solo lo que dice la API (true), nada mas. */
export function esEstimada(fila) {
  return (fila?.entradaEstimada ?? fila?.entrada_estimada) === true;
}

/** El texto de la entrada: la estimada lleva la palabra y el metodo; la marcada, solo la hora. */
export function textoDeEntrada(fila) {
  const hora = texto(fila?.horaEntradaReal).trim();
  if (!hora) return '';
  if (!esEstimada(fila)) return `entrada ${hora}`;
  return `Entrada estimada ${hora} (${metodoEnPalabras(fila?.metodoEntrada ?? fila?.metodo_entrada)})`;
}

export const TITULO_DEL_CONTADOR = 'Días con entrada estimada este periodo';
export const AYUDA_DEL_CONTADOR = 'Días en que la hora de entrada no la marcó la persona. No es una sanción: muestra el patrón.';

/** El contador por persona, de mayor a menor (la API ya lo ordena; se ordena igual por si acaso). Solo quien tuvo alguno. */
export function contadorPorPersona(payload) {
  const lista = payload?.estimadasPorColaborador ?? payload?.estimadas_por_colaborador ?? [];
  return (Array.isArray(lista) ? lista : [])
    .map((e) => ({ colaboradorId: texto(e?.colaboradorId ?? e?.colaborador_id), nombre: texto(e?.nombreCompleto ?? e?.nombre_completo), dias: Number(e?.dias) || 0 }))
    .filter((e) => e.dias > 0)
    .sort((a, b) => b.dias - a.dias || a.nombre.localeCompare(b.nombre, 'es'));
}

/** Total de dias con entrada estimada del periodo (el agregado de la API). */
export function diasConEntradaEstimada(payload) {
  return Number(payload?.diasEntradaEstimada ?? payload?.dias_entrada_estimada) || 0;
}
